var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPerms(_vm.perms))?_c('el-button',{attrs:{"size":_vm.size,"type":_vm.type,"loading":_vm.loading,"disabled":!_vm.hasPerms(_vm.perms)},on:{"click":_vm.handleClick}},[_c('el-link',{attrs:{"icon":_vm.icon,"type":"primary","size":_vm.size}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caa87462","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button/DButtonIcon.vue
// module id = null
// module chunks = 